/**
 * Token Manager
 * Centralized token management with refresh capability
 */

// ===========================================
// Token Keys
// ===========================================
const TOKEN_KEYS = {
    ACCESS: 'access_token',
    REFRESH: 'refresh_token',
} as const;

// ===========================================
// Token Manager
// ===========================================
export const TokenManager = {
    // Access Token
    getToken: (): string | null => localStorage.getItem(TOKEN_KEYS.ACCESS),
    setToken: (token: string): void => localStorage.setItem(TOKEN_KEYS.ACCESS, token),
    removeToken: (): void => localStorage.removeItem(TOKEN_KEYS.ACCESS),
    hasToken: (): boolean => !!localStorage.getItem(TOKEN_KEYS.ACCESS),

    // Refresh Token
    getRefreshToken: (): string | null => localStorage.getItem(TOKEN_KEYS.REFRESH),
    setRefreshToken: (token: string): void => localStorage.setItem(TOKEN_KEYS.REFRESH, token),
    removeRefreshToken: (): void => localStorage.removeItem(TOKEN_KEYS.REFRESH),
    hasRefreshToken: (): boolean => !!localStorage.getItem(TOKEN_KEYS.REFRESH),

    // Clear all tokens
    clear: (): void => {
        localStorage.removeItem(TOKEN_KEYS.ACCESS);
        localStorage.removeItem(TOKEN_KEYS.REFRESH);
    },

    // Alias for backward compatibility
    clearTokens: (): void => {
        localStorage.removeItem(TOKEN_KEYS.ACCESS);
        localStorage.removeItem(TOKEN_KEYS.REFRESH);
    },

    // Set both tokens at once
    setTokens: (accessToken: string, refreshToken?: string): void => {
        localStorage.setItem(TOKEN_KEYS.ACCESS, accessToken);
        if (refreshToken) {
            localStorage.setItem(TOKEN_KEYS.REFRESH, refreshToken);
        }
    },
};

export default TokenManager;
